/**
 * Created with setting codegen.
 */
import { configuration } from "@faire/web/common/settings/declarations/configuration";

/**
 * PostHog API key for web analytics.
 */
export const FE_POSTHOG_API_KEY_251001 = configuration({
  name: "FE_POSTHOG_API_KEY_251001",
  identifier: "RetailerTokenOrBrandTokenOrLoggedOutSessionToken",
  defaultValue: "phc_OXVFxcPiPlW03tkty7K6VKnE3CIXoZqDNBzaAHQHQlr",
  client: ["RETAILER", "VISITOR_WEB", "MAKER"],
  productArea: "HOTJAR_CONFIG",
});
